import { HTMLElementBase } from './HTMLElementBase';
import {HTMLElement} from "./HTMLElement";
export class HTMLPictureElement extends HTMLElement { constructor(tagName: string = 'PICTURE', ownerDocument?: any) { super(tagName, ownerDocument); } }
